import styled from "styled-components";

export const IconImg = styled.img`
  width: 16px;
  height: 16px;
  margin-left: 10px;
`;

export const Container = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  width: max-content;

  :hover {
    opacity: 0.6;
    cursor: pointer;
  }
`;
